import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_RESIGNED_EMPLOYEE_HISTORY_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const ResignedEmployeesHistoryReport = lazy(() =>
  import('../../../screens/ResignedEmployeesHistoryReport')
    .then(module => ({default: module.ResignedEmployeesHistoryReport})));

const ResignedEmployeesHistoryReportNavigation = [
  {
    path: ROUTE_RESIGNED_EMPLOYEE_HISTORY_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ResignedEmployeesHistoryReport />
      </Suspense>
    ),
  },
];

export default ResignedEmployeesHistoryReportNavigation;
